var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#001965"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5043 16.8349V20.1696C23.5043 22.0113 22.0113 23.5043 20.1696 23.5043H11.8328C9.99105 23.5043 8.49805 22.0113 8.49805 20.1696V11.8328C8.49805 9.99105 9.99105 8.49805 11.8328 8.49805H17.6685",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.834 16.9267L19.4617 16.6024C19.6457 16.5795 19.8167 16.4959 19.9478 16.3648L23.8086 12.5041C24.513 11.7993 24.513 10.6569 23.8086 9.95215V9.95215C23.1038 9.24772 21.9615 9.24772 21.2567 9.95215L17.4551 13.7537C17.3274 13.8813 17.2446 14.0469 17.2191 14.2256L16.834 16.9267Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49805 16.4634L11.7427 13.2179C12.3569 12.6044 13.352 12.6044 13.9662 13.2179V13.2179C14.5796 13.8321 14.5796 14.8271 13.9662 15.4413L12.9441 16.4634L13.0341 16.3734L11.9228 17.4847C11.6278 17.7794 11.462 18.1794 11.462 18.5964C11.462 19.0134 11.6278 19.4134 11.9228 19.7081V19.7081C12.537 20.3216 13.532 20.3216 14.1462 19.7081L15.1675 18.686",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIcon);
export default __webpack_public_path__ + "static/media/SignIcon.ec516cb79ddd18f541ebc22f9ae0e6b4.svg";
export { ForwardRef as ReactComponent };